const titleLevelStylePropertiesOptions = {
    fontSize: {
        type: "number",
        label: "Taille de police",
        step: 1,
        max: 18,
        min: 6,
    },
    color: {
        type: "color",
        label: "Couleur du texte",
    },
    italic: {
        type: "boolean",
        label: "Texte en italique",
    },
    bold: {
        type: "boolean",
        label: "Texte en gras",
    },
};

export const generalThemeSettingsOptions: any = {
    label: "Général",
    properties: {
        fontSize: {
            type: "number",
            label: "Taille de police",
            step: 1,
            max: 18,
            min: 6,
        },
        fontFamily: {
            type: "select",
            label: "Police",
            choices: [
                { value: "Arial", text: "Arial" },
                { value: "Calibri", text: "Calibri" },
                { value: "Helvetica", text: "Helvetica" },
                { value: "Lato", text: "Lato" },
                { value: "Mulish", text: "Mulish" },
                { value: "Roboto", text: "Roboto" },
                { value: "Tahoma", text: "Tahoma" },
                { value: "Times New Roman", text: "Times New Roman" },
                { value: "Verdana", text: "Verdana" },
            ],
        },
    },
    // title: {
    //     label: "Format du titre",
    //     properties: {
    //         bold: {
    //             type: "boolean",
    //             label: "Texte en gras"
    //         }
    //     }
    // },
    boxStyle: {
        label: "Style des boîtes",
        properties: {
            fill: {
                type: "color",
                label: "Remplissage",
            },
            border: {
                type: "boolean",
                label: "Bordures",
            },
            stroke: {
                type: "color",
                label: "Couleur des bordures",
                enableConditions: [{ key: "border", value: true }],
            },
            borderRadius: {
                type: "number",
                label: "Rayon des bordures",
                // enableConditions: [
                //     { key: "border", value: true }
                // ]
            },
        },
    },
    boxTitleStyle: {
        label: "Style du titre de la boîte",
        properties: {
            color: {
                type: "color",
                label: "Couleur du texte",
            },
            fill: {
                type: "color",
                label: "Remplissage",
            },
            border: {
                type: "boolean",
                label: "Bordures",
            },
            stroke: {
                type: "color",
                label: "Couleur des bordures",
                enableConditions: [{ key: "border", value: true }],
            },
            borderRadius: {
                type: "number",
                label: "Rayon des bordures",
                // enableConditions: [
                //     { key: "border", value: true }
                // ]
            },
            bold: {
                type: "boolean",
                label: "Texte en gras",
            },
        },
    },
    // h1: {
    //     fontSize: 14,
    //     color: this.defaultTextColor,
    //     italic: false,
    //     bold: true
    // },
    h1: {
        label: "Format du titre 1",
        type: "TEXT_STYLE",
        properties: titleLevelStylePropertiesOptions,
    },
    h2: {
        label: "Format du titre 2",
        type: "TEXT_STYLE",
        properties: titleLevelStylePropertiesOptions,
    },
    h3: {
        label: "Format du titre 3",
        type: "TEXT_STYLE",
        properties: titleLevelStylePropertiesOptions,
    },
};

export const chartsThemeSettingsOptions: any = {
    label: "Graphique",
    properties: {
        type: {
            type: "select",
            label: "Type de graphique",
            choices: [
                { value: "bar", text: "Barres" },
                { value: "line", text: "Lignes" },
                { value: "pie", text: "Secteurs" },
                { value: "doughnut", text: "Doughnut" },
            ],
            // prerequisites: [
            //     { key: "ui", value: "chart" }
            // ]
        },
        palette: {
            type: "select",
            label: "Palette de couleurs",
            choices: [
                { value: "cool", text: "Cool" },
                { value: "warm", text: "Chaleureux" },
                { value: "neon", text: "Néon" },
            ],
            // prerequisites: [
            //     { key: "ui", value: "chart" }
            // ]
        },
    },
    title: {
        label: "Format des titres des graphiques",
        properties: {
            bold: {
                type: "boolean",
                label: "Gras",
            },
        },
    },
};

export const tablesThemeSettingsOptions: any = {
    label: "Tableau",
    header: {
        label: "En-tête",
        properties: {
            background: {
                type: "color",
                label: "Remplissage",
            },
            color: {
                type: "color",
                label: "Couleur du texte",
            },
            textAlign: {
                type: "select",
                label: "Position du texte",
                choices: [
                    { value: "left", text: "A gauche" },
                    { value: "center", text: "Au centre" },
                    { value: "right", text: "A droite" },
                ],
            },
            border: {
                type: "boolean",
                label: "Bordures",
            },
            borderColor: {
                type: "color",
                label: "Couleur des bordures",
                enableConditions: [{ key: "border", value: true }],
            },
            bold: {
                type: "boolean",
                label: "Texte en gras",
            },
        },
    },
    rows: {
        label: "Lignes du tableau",
        properties: {
            background: {
                type: "color",
                label: "Remplissage",
            },
            color: {
                type: "color",
                label: "Couleur du texte",
            },
            textAlign: {
                type: "select",
                label: "Position du texte",
                choices: [
                    { value: "left", text: "A gauche" },
                    { value: "center", text: "Au centre" },
                    { value: "right", text: "A droite" },
                ],
            },
            border: {
                type: "boolean",
                label: "Bordures",
            },
            borderColor: {
                type: "color",
                label: "Couleur des bordures",
                enableConditions: [{ key: "border", value: true }],
            },
            bold: {
                type: "boolean",
                label: "Texte en gras",
            },
            mode: {
                type: "select",
                label: "Mode des lignes",
                choices: [
                    { value: "simple", text: "Simple" },
                    { value: "alternating", text: "Couleurs alternées" },
                ],
            },
            secondaryColor: {
                type: "color",
                label: "Couleur secondaires des lignes",
                enableConditions: [{ key: "mode", value: "alternating" }],
            },
        },
    },
    title: {
        label: "Format des lignes de titre",
        properties: {
            background: {
                type: "color",
                label: "Remplissage",
            },
            color: {
                type: "color",
                label: "Couleur du texte",
            },
            bold: {
                type: "boolean",
                label: "Gras",
            },
        },
    },
    subtotals: {
        label: "Format des sous-totaux",
        properties: {
            background: {
                type: "color",
                label: "Remplissage",
            },
            color: {
                type: "color",
                label: "Couleur du texte",
            },
            bold: {
                type: "boolean",
                label: "Texte en gras",
            },
        },
    },
    totals: {
        label: "Format des totaux",
        properties: {
            background: {
                type: "color",
                label: "Remplissage",
            },
            color: {
                type: "color",
                label: "Couleur du texte",
            },
            bold: {
                type: "boolean",
                label: "Texte en gras",
            },
        },
    },
    footer: {
        label: "Pied de tableau",
        properties: {
            background: {
                type: "color",
                label: "Remplissage",
            },
            color: {
                type: "color",
                label: "Couleur du texte",
            },
            textAlign: {
                type: "select",
                label: "Position du texte",
                choices: [
                    { value: "left", text: "A gauche" },
                    { value: "center", text: "Au centre" },
                    { value: "right", text: "A droite" },
                ],
            },
            border: {
                type: "boolean",
                label: "Bordures",
            },
            borderColor: {
                type: "color",
                label: "Couleur des bordures",
                enableConditions: [{ key: "border", value: true }],
            },
            bold: {
                type: "boolean",
                label: "Texte en gras",
            },
        },
    },
};
